import axios, { AxiosInstance } from 'axios';
import { useContext, createContext, useMemo } from 'react';
import { attachSessionInterceptors } from '@/shared/axiosSessionInterceptor';

declare module 'axios' {
  export interface AxiosRequestConfig {
    disableInterceptor?: boolean;
  }
}

interface HookProps {
  axiosCtx: AxiosInstance;
}

const FetchAxiosContex = createContext<HookProps>({} as HookProps);

const FetchProvider: React.FC<any> = ({ children }) => {
  const axiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: window.agp_config.REACT_APP_AWS,
    });

    return attachSessionInterceptors(instance);
  }, []);

  return <FetchAxiosContex.Provider value={{ axiosCtx: axiosInstance }}>{children}</FetchAxiosContex.Provider>;
};

const useFetchAxios = (): HookProps => {
  const ctx = useContext(FetchAxiosContex);

  if (!ctx) throw new Error('Erro ao usar hook Header');

  return ctx;
};

export { FetchProvider, useFetchAxios };
